const translation = {
  pt_BR: {
    form_title: 'Cadastrar',
    button_register: 'Confirmar',
    button_have_account: 'Eu já tenho uma conta',
    label_name: 'NOME',
    input_placeholder_name: 'seu nome',
    label_email: 'E-MAIL',
    input_placeholder_email: 'seu e-mail',
    label_password: 'SENHA',
    label_password_confirm: 'CONFIRMAÇÃO DA SENHA',
    input_placeholder_password: 'sua senha',
    label_city: 'CIDADE',
    label_state: 'ESTADO',
    label_country: 'PAÍS',
    label_company: 'EMPRESA',
    label_telephone: 'TELEFONE (OPCIONAL)',
    input_placeholder_company: 'sua empresa',
    input_placeholder_city: 'cidade',
    error_notfound_name: 'informe o nome',
    error_notfound_company: 'informe a empresa',
    error_invalid_email: 'informe um e-mail válido',
    error_notfound_city: 'informe a cidade',
    error_notfound_city_state: 'informe o estado da cidade',
    error_notfound_country: 'informe o país',
    error_notfound_password: 'informe a senha',
    error_min_required_password: 'A senha deve ter no mínimo 6 dígitos',
    error_password_confirm_required: 'A confirmação de senha é obrigatória',
    error_password_confirm_not_match: 'A confirmação de senha não confere',
    email_exist_message: 'Este e-mail já está em uso. Escolha outro!',
    success_message: 'Cadastrado com sucesso. Acesse com sua nova conta.',
  },
  en_US: {
    form_title: 'Register',
    button_register: 'Confirm',
    button_have_account: 'I already have an account',
    label_name: 'NAME',
    input_placeholder_name: 'your name',
    label_email: 'E-MAIL',
    input_placeholder_email: 'your e-mail',
    label_password: 'PASSWORD',
    label_password_confirm: 'CONFIRM PASSWORD',
    input_placeholder_password: 'your password',
    label_city: 'CITY',
    label_state: 'STATE',
    label_country: 'COUNTRY',
    label_company: 'COMPANY',
    label_telephone: 'PHONE (OPTIONAL)',
    input_placeholder_company: 'your company',
    input_placeholder_city: 'your country',
    error_notfound_name: 'name is required',
    error_notfound_company: 'company is required',
    error_notfound_city: 'city is required',
    error_notfound_city_state: 'city state is required',
    error_notfound_country: 'country is required',
    error_notfound_password: 'password is required',
    error_min_required_password: 'Password must be at least 6 digits',
    success_message: 'Registered successfully. Sign in with your new account.',
    email_exist_message: 'This email is already in use. Choose another!',
    error_invalid_email: 'invalid mail',
    error_password_confirm_required: 'Password confirmation is required',
    error_password_confirm_not_match: 'Password confirmation does not match',
  },
};

export default translation;
